import { requireNotNull, sanityCheck } from "@whilecat/core/utils/validation.ts";

export function arraysEqual<T>(arr1: Array<T>, arr2: Array<T>) {
    requireNotNull(arr1);
    requireNotNull(arr2);

    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
}

export function shuffleArray<T>(array: T[]) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export function getRandomElement<T>(array: T[]) {
    requireNotNull(array);
    sanityCheck(array.length > 0, "must not be empty");

    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
}

/* pairwise([1, 2, 3]) === [[1, 2], [2, 3]] */
export const pairwise = <T>(arr: T[]) => arr.map((_, index) => [arr[index], arr[index + 1]]).slice(0, -1);

/* Array.from(zipit([1, 2, 3, 4], ['a', 'b', 'c'])) === [[1, 'a'], [2, 'b'], [3, 'c']]
   Works with any iterables, such as generators. */
export function* zipit<A, B>(a: Iterable<A>, b: Iterable<B>): Generator<[A, B], undefined, undefined> {
    let iterators = [a, b].map(i => i[Symbol.iterator]());
    while (true) {
        let results = iterators.map(iter => iter.next());
        if (results.some(res => res.done)) return;
        // @ts-ignore typescript doesn't get it
        else yield results.map(res => res.value);
    }
}

/* zip([1, 2, 3, 4], ['a', 'b', 'c']) === [[1, 'a'], [2, 'b'], [3, 'c']] */
export const zip = <A, B>(a: A[], b: B[]) => Array.from(zipit(a, b));

export function* cycle<T>(arr: T[]) {
    while (true) {
        yield* arr;
    }
}

export function* range(n: number) {
    for (let i = 0; i < n; i++) yield i;
}

export function* repeat(s: string, n: number) {
    for (const _ of range(n)) yield s;
}
